import MilestonesAdapter from './base';

export default class Level extends MilestonesAdapter {
  modelNamePlural = 'levels';
}
